import { element as ngElement } from 'angular';
var DomUtils = /** @class */ (function () {
    function DomUtils() {
    }
    DomUtils.prototype.isScrolledIntoView = function (element, threshold) {
        var _a;
        var $element = ngElement(element);
        var $window = ngElement(window);
        var docViewTop = $window.scrollTop();
        var docViewBottom = docViewTop + $window.height();
        var elemTop = ((_a = $element.offset()) === null || _a === void 0 ? void 0 : _a.top) || 0;
        var elemBottom = elemTop + $element.outerHeight();
        return ((elemTop > docViewTop && elemTop + threshold < docViewBottom) ||
            (elemTop < docViewTop && elemBottom > docViewBottom) ||
            (elemBottom > docViewTop && elemBottom < docViewBottom));
    };
    DomUtils.prototype.getEndLocation = function (element, offset) {
        var location = 0;
        var offsetNumber = offset || 0;
        if (element.offsetParent) {
            do {
                location += element.offsetTop;
                element = element.offsetParent;
            } while (element);
        }
        location = Math.max((location || 0) - offsetNumber, 0);
        return location;
    };
    DomUtils.prototype.getElement = function (elementId) {
        var targetElement = document.getElementById(elementId);
        if (!targetElement) {
            targetElement = this.tryGetFormElement(elementId);
            if (!targetElement) {
                return null;
            }
        }
        return targetElement;
    };
    DomUtils.prototype.tryGetFormElement = function (elementId) {
        var scrollToElement = ngElement('[data-wffm="' + elementId + '"]');
        if (scrollToElement.length === 0) {
            return null;
        }
        return scrollToElement[0];
    };
    return DomUtils;
}());
export { DomUtils };
export var domUtils = new DomUtils();
